// countries.js — Country configuration data

export const COUNTRIES = {
  US: {
    name: 'United States',
    flag: '🇺🇸',
    currency: 'USD',
    symbol: '$',
    defaultSalary: 75000,
    regions: {
      X: 'No State Tax',
      AL: 'Alabama', AK: 'Alaska', AZ: 'Arizona', AR: 'Arkansas',
      CA: 'California', CO: 'Colorado', CT: 'Connecticut', DE: 'Delaware',
      FL: 'Florida', GA: 'Georgia', HI: 'Hawaii', ID: 'Idaho',
      IL: 'Illinois', IN: 'Indiana', IA: 'Iowa', KS: 'Kansas',
      KY: 'Kentucky', LA: 'Louisiana', ME: 'Maine', MD: 'Maryland',
      MA: 'Massachusetts', MI: 'Michigan', MN: 'Minnesota', MS: 'Mississippi',
      MO: 'Missouri', MT: 'Montana', NE: 'Nebraska', NV: 'Nevada',
      NH: 'New Hampshire', NJ: 'New Jersey', NM: 'New Mexico', NY: 'New York',
      NC: 'North Carolina', ND: 'North Dakota', OH: 'Ohio', OK: 'Oklahoma',
      OR: 'Oregon', PA: 'Pennsylvania', RI: 'Rhode Island', SC: 'South Carolina',
      SD: 'South Dakota', TN: 'Tennessee', TX: 'Texas', UT: 'Utah',
      VT: 'Vermont', VA: 'Virginia', WA: 'Washington', WV: 'West Virginia',
      WI: 'Wisconsin', WY: 'Wyoming', DC: 'Washington D.C.'
    },
    statuses: { single: 'Single', married: 'Married Filing Jointly', hoh: 'Head of Household' },
    defaultRegion: 'TX',
    defaultStatus: 'single'
  },
  UK: {
    name: 'United Kingdom',
    flag: '🇬🇧',
    currency: 'GBP',
    symbol: '£',
    defaultSalary: 45000,
    regions: { ENG: 'England / Wales / N.Ireland', SCT: 'Scotland' },
    statuses: { single: 'Standard' },
    defaultRegion: 'ENG',
    defaultStatus: 'single'
  },
  IN: {
    name: 'India',
    flag: '🇮🇳',
    currency: 'INR',
    symbol: '₹',
    defaultSalary: 1200000,
    regions: { X: 'All States' },
    statuses: { new: 'New Tax Regime', old: 'Old Tax Regime' },
    defaultRegion: 'X',
    defaultStatus: 'new'
  },
  CA: {
    name: 'Canada',
    flag: '🇨🇦',
    currency: 'CAD',
    symbol: 'CA$',
    defaultSalary: 80000,
    regions: {
      AB: 'Alberta', BC: 'British Columbia', MB: 'Manitoba',
      NB: 'New Brunswick', NS: 'Nova Scotia', ON: 'Ontario',
      QC: 'Quebec', SK: 'Saskatchewan'
    },
    statuses: { single: 'Single', married: 'Married' },
    defaultRegion: 'ON',
    defaultStatus: 'single'
  },
  AU: {
    name: 'Australia',
    flag: '🇦🇺',
    currency: 'AUD',
    symbol: 'A$',
    defaultSalary: 85000,
    regions: { X: 'All States' },
    statuses: { resident: 'Resident', nonresident: 'Non-Resident' },
    defaultRegion: 'X',
    defaultStatus: 'resident'
  },
  DE: {
    name: 'Germany',
    flag: '🇩🇪',
    currency: 'EUR',
    symbol: '€',
    defaultSalary: 55000,
    regions: { X: 'All States' },
    statuses: { single: 'Single (Class I)', married: 'Married (Class III)' },
    defaultRegion: 'X',
    defaultStatus: 'single'
  },
  FR: {
    name: 'France',
    flag: '🇫🇷',
    currency: 'EUR',
    symbol: '€',
    defaultSalary: 42000,
    regions: { X: 'All Regions' },
    statuses: { single: 'Single', married: 'Married (2 parts)', family: 'Family (2.5 parts)' },
    defaultRegion: 'X',
    defaultStatus: 'single'
  },
  SG: {
    name: 'Singapore',
    flag: '🇸🇬',
    currency: 'SGD',
    symbol: 'S$',
    defaultSalary: 72000,
    regions: { X: 'Singapore' },
    statuses: { resident: 'Tax Resident', nonresident: 'Non-Resident' },
    defaultRegion: 'X',
    defaultStatus: 'resident'
  },
  AE: {
    name: 'UAE',
    flag: '🇦🇪',
    currency: 'AED',
    symbol: 'AED',
    defaultSalary: 240000,
    regions: { X: 'All Emirates' },
    statuses: { single: 'Standard' },
    defaultRegion: 'X',
    defaultStatus: 'single'
  },
  JP: {
    name: 'Japan',
    flag: '🇯🇵',
    currency: 'JPY',
    symbol: '¥',
    defaultSalary: 6000000,
    regions: { X: 'All Prefectures' },
    statuses: { single: 'Single' },
    defaultRegion: 'X',
    defaultStatus: 'single'
  },
  NL: {
    name: 'Netherlands',
    flag: '🇳🇱',
    currency: 'EUR',
    symbol: '€',
    defaultSalary: 55000,
    regions: { X: 'All Provinces' },
    statuses: { single: 'Single' },
    defaultRegion: 'X',
    defaultStatus: 'single'
  },
  SE: {
    name: 'Sweden',
    flag: '🇸🇪',
    currency: 'SEK',
    symbol: 'kr',
    defaultSalary: 600000,
    regions: { X: 'All Municipalities' },
    statuses: { single: 'Standard' },
    defaultRegion: 'X',
    defaultStatus: 'single'
  }
};

export const COUNTRY_LIST = Object.entries(COUNTRIES).map(([code, data]) => ({
  code,
  ...data
}));

// National average salaries (USD equivalent, 2024)
export const NATIONAL_AVERAGES_USD = {
  US: 59540, UK: 42000, IN: 8000, CA: 55000,
  AU: 65000, DE: 50000, FR: 42000, SG: 60000,
  AE: 42000, JP: 35000, NL: 52000, SE: 52000
};